import { z } from 'zod';
import type { TFunction } from 'i18next';

export function createResetPasswordSchema(t: TFunction) {
  return z
    .object({
      newPassword: z
        .string()
        .min(8, t('validation.password_min'))
        .regex(/[a-zA-Z]/, t('validation.password_letter'))
        .regex(/[0-9]/, t('validation.password_number')),
      confirmPassword: z
        .string()
        .min(1, t('validation.confirm_new_password_required')),
    })
    .refine((data) => data.newPassword === data.confirmPassword, {
      message: t('validation.passwords_mismatch'),
      path: ['confirmPassword'],
    });
}

export type ResetPasswordFormValues = z.infer<ReturnType<typeof createResetPasswordSchema>>;
